module.exports = __webpack_public_path__ + "static/media/image-card-8.50149364.png";